// JAVÍTÁS: a '12' periódusérték TEREM (csarnok) szabály esetén a "7 méteres
// dobások" (a hosszabbítások utáni büntetődobás-sorozat) - vagyis IDŐBEN AZ
// EGYIK LEGUTOLSÓ periódus, közvetlenül a "Mérkőzés vége" (13) előtt. Itt
// korábban '2' szerepelt (a "Félidő" (2) elé, mindjárt az I. félidő (1)
// után!) - ez valószínűleg egy másik szabályváltozat öröksége volt. Emiatt
// az események rendezésekor (TimelineList.vue, dmr.js stb., mind ezen a
// közös táblázaton keresztül) a 7m dobások eseményei nem a lista tetejére
// (időben legutolsóként), hanem tévesen az I. félidő eseményei KÖZÉ, azok
// után kerültek. A STRAND (strandkézilabda) változat már korábban is
// helyesen 98-ra (a végéhez közel) állította ezt felülírással - most az
// alap táblázatban (TEREM-nél is használt érték) is ugyanez a helyes,
// "későn" jövő sorrend érvényesül.
const CHRONO_MAP = {
    '0': 0, '1': 1, '2': 3, '3': 4,
    '14': 5, '4': 6, '5': 7, '15': 8, '6': 9, '7': 10,
    '16': 11, '8': 12, '9': 13, '17': 14, '10': 15,
    '11': 16, '12': 98, '18': 17, '13': 99
};
const CHRONO_MAP_STRAND = { ...CHRONO_MAP, '12': 98 };

export function getChronoOrder(value, isStrand = false) {
    if (value === null || value === undefined) return 0;
    const map = isStrand ? CHRONO_MAP_STRAND : CHRONO_MAP;
    return map[String(value)] !== undefined ? map[String(value)] : parseInt(value);
}

export function comparePeriods(a, b, isStrand = false) {
    return getChronoOrder(a, isStrand) - getChronoOrder(b, isStrand);
}
